import { render, staticRenderFns } from "./webzine-magazine-article-media.vue?vue&type=template&id=09db2d10"
import script from "./webzine-magazine-article-media.vue?vue&type=script&lang=js"
export * from "./webzine-magazine-article-media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports